module.exports = __webpack_public_path__ + "static/media/create_filled.d956bc12.png";